import { MAX_PARTNERS_BY_DRAFTS } from 'constants/defaultConstants';
import { getStockPlans } from 'modules/beneficiaries/redux/planActions';
import { useGetPartners } from 'modules/partners/hooks/useGetPartners';
import { getHoldingClasses } from 'modules/partners/redux/holdingClassActions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { getDrafts } from '../redux/draftActions';

type UseDraftSellProps = {
  societyId: string;
};

const useDraftSell = ({ societyId }: UseDraftSellProps) => {
  const dispatch = useDispatch();

  const actualSociety = useSelector(
    (state: State) => state?.society?.actualSociety
  );
  const drafts = useSelector((state: State) => state?.drafts);
  const partners = useSelector((state: State) => state?.partners);
  const user = useSelector((state: State) => state?.user);

  useGetActualSociety(societyId);

  useGetPartners({
    societyId,
    partnerId: '',
    categoryId: '',
    page: 1,
    items: MAX_PARTNERS_BY_DRAFTS,
  });

  useEffect(() => {
    if (societyId) {
      dispatch(getHoldingClasses({ societyId }));
      dispatch(getStockPlans(societyId));
    }
  }, [societyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (societyId && !drafts?.length) {
      dispatch(getDrafts(societyId));
    }
  }, [societyId, drafts]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data: {
      user,
      actualSociety,
      drafts,
      partners,
    },
    isLoading: false,
    isError: false,
  };
};

export default useDraftSell;
